import { createContext } from "react";

const achievementsContext = createContext();

export default achievementsContext;